import { render, staticRenderFns } from "./matchList.vue?vue&type=template&id=227357ba&scoped=true&"
import script from "./matchList.vue?vue&type=script&lang=js&"
export * from "./matchList.vue?vue&type=script&lang=js&"
import style0 from "./matchList.vue?vue&type=style&index=0&id=227357ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227357ba",
  null
  
)

export default component.exports